// @flow

import { observer } from "mobx-react";
import React from "react";

import User from "app/models/User";

import UserCard from "app/components/UserCard/UserCard";

type Props = {
    users: User[]
};

@observer
export default class UserCards extends React.Component<Props> {
    render() {
        return (
            <div className="UserCards clearfix">
                <div className="row">{this.renderUsers()}</div>
            </div>
        );
    }

    renderUsers() {
        return this.props.users.map(user => {
            return (
                <div key={user.rowid} className="col-md-4">
                    <UserCard user={user} />
                </div>
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/UserCards/UserCards.js